<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-sede-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../utils/funciones';

export default {
  name: 'ListadoSedeUniversidad',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CODIGO',
          field: 'codigo',
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'INSTITUCIÓN',
          field: 'institucion.nombre',
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'UNIDAD DE NEGOCIO',
          cellRenderer: (params) => {
            return params.data?.unidadNegocio?.nombre || '-';
          },
          valueGetter: (params) => {
            return params.data?.unidadNegocio?.nombre || '-';
          },
          minWidth: 300,
          maxWidth: 300,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-sede-universidad {
  height: calc(var(--vh, 1vh) * 100 - 14rem);
}
</style>
  